import React, {createContext, useContext} from 'react'
import languages, {Language} from '../copy'

const LanguageContext = createContext(null)

export const useLanguage = () => {
	const context = useContext(LanguageContext)
	const {language} = context
	return language
}

export const LanguageProvider = ({children, language, copy = null}) => {
	return (
		<LanguageContext.Provider value={{language, copy}}>
			{children}
		</LanguageContext.Provider>
	)
}

export const useTranslation = <K extends keyof Language = undefined>(
	prefix?: K
): K extends undefined ? Language : Language[K] => {
	const language = useLanguage()
	const context = useContext(LanguageContext)
	const copy = context?.copy || languages[language]
	return prefix ? copy[prefix] : copy
}
